import React from 'react';
import styles from "./404.module.scss";
import BG from "../About/assets/bg_about.png";
import BGLow from "../About/assets/bg_about_low.png";
import InnerPage from "../../components/InnerPage";
import Container from "../../components/Container";
import { useTranslation } from "react-i18next";
import Page from "../../components/Page";

const Error = () => {
  const [t] = useTranslation("global");

  return (
    <Page>
      <InnerPage className={styles.wrapper} background={BG} lowBackground={BGLow}>
        <Container>
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className={styles.error}>
                <h4>{t("server_errors.bad_request")}</h4>
              </div>
            </div>
          </div>
        </Container>
      </InnerPage>
    </Page>
  );
};

export default Error;